import React,{useState} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMenu,FiX,FiCode,FiUsers,FiMail,FiSettings,FiBookOpen,FiBriefcase}=FiIcons;

const Header=()=> {
  const [isMenuOpen,setIsMenuOpen]=useState(false);

  const navItems=[
    {name: 'Home',href: '#home',icon: FiCode},
    {name: 'Services',href: '#services',icon: FiSettings},
    {name: 'About',href: '#about',icon: FiUsers},
    {name: 'Contact',href: '#contact',icon: FiMail},
    {name: 'CEO Partner',href: 'https://ceo-wanted.appscamelot.com/',icon: FiBriefcase,external: true},
    {name: 'Blog',href: 'https://appscamelot.com/blog/',icon: FiBookOpen,external: true}
  ];

  const scrollToSection=(href)=> {
    if (href.startsWith('http')) {
      window.open(href,'_blank','noopener,noreferrer');
      setIsMenuOpen(false);
      return;
    }

    const element=document.querySelector(href);

    if (element) {
      const headerHeight=80;
      const elementPosition=element.offsetTop - headerHeight;
      window.scrollTo({top: elementPosition,behavior: 'smooth'});
    }

    setIsMenuOpen(false);
  };

  return (
    <motion.header
      initial={{y: -100}}
      animate={{y: 0}}
      className="fixed top-0 w-full bg-white/95 backdrop-blur-md shadow-lg z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <motion.div
            whileHover={{scale: 1.05}}
            className="flex items-center space-x-3 cursor-pointer"
            onClick={()=> scrollToSection('#home')}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center overflow-hidden">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753292926473-appscamelot-icon.png"
                alt="AppsCamelot Icon"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent">
                AppsCamelot
              </h1>
              <p className="text-xs text-gray-600">AI Automation Services</p>
            </div>
          </motion.div>

          <nav className="hidden md:flex space-x-8">
            {navItems.map((item)=> (
              <motion.button
                key={item.name}
                onClick={()=> scrollToSection(item.href)}
                whileHover={{scale: 1.05}}
                className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 transition-colors duration-200"
              >
                <SafeIcon icon={item.icon} className="text-sm" />
                <span className="font-medium">{item.name}</span>
              </motion.button>
            ))}
          </nav>

          <button
            onClick={()=> setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-xl" />
          </button>
        </div>

        {isMenuOpen && (
          <motion.nav
            initial={{opacity: 0,y: -20}}
            animate={{opacity: 1,y: 0}}
            className="md:hidden py-4 border-t border-gray-200"
          >
            {navItems.map((item)=> (
              <button
                key={item.name}
                onClick={()=> scrollToSection(item.href)}
                className="flex items-center space-x-3 py-3 w-full text-left text-gray-700 hover:text-blue-600 transition-colors"
              >
                <SafeIcon icon={item.icon} className="text-lg" />
                <span className="font-medium">{item.name}</span>
              </button>
            ))}
          </motion.nav>
        )}
      </div>
    </motion.header>
  );
};

export default Header;